import { Box, Button, Container, Paper, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { Subheader } from 'components';
import LotteryDetails from 'features/lotteries/LotteryDetails';
import { useLotteries } from 'hooks';

const LotteryShow = ({ ...props }) => {
	const navigate = useNavigate();
	const { id } = useParams();

	const { isLoading, lottery, findLottery } = useLotteries({
		id: id
	});

	const handleEditClick = () => navigate(`/lotteries/${id}/edit`);

	useEffect(() => {
		if (id) findLottery(id);
	}, []);

	return (
		<>
			<Subheader
				title={isLoading ? 'Loading...' : lottery.title}
				buttons={[
					<Button onClick={handleEditClick} color="primary" variant="contained">
						Edit
					</Button>
				]}
			/>
			<Container>
				<Paper>
					<Box p={4}>
						<LotteryDetails lottery={lottery} />
					</Box>
				</Paper>
			</Container>
		</>
	);
};

export default LotteryShow;
